exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-history-img[data-v-4617646e]{-o-object-fit:contain;object-fit:contain}", ""]);

// exports
